import { render, staticRenderFns } from "./BaseLink.vue?vue&type=template&id=24650766"
import script from "./BaseLink.vue?vue&type=script&lang=ts"
export * from "./BaseLink.vue?vue&type=script&lang=ts"
import style0 from "./BaseLink.vue?vue&type=style&index=0&id=24650766&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports